export const getColumnClass = (deviceType) => {
	if (deviceType === 'DESKTOP') {
		return 'col-xs-4';
	} else if (deviceType === 'MOBILE') {
		return 'col-xs-12';
	} else {
		return 'col-xs-12';
	}
};
